// extracted by mini-css-extract-plugin
module.exports = {"container":"category_detail_container__1bG5b","bottomComponent":"category_detail_bottomComponent__gRFuT","btn_primary":"category_detail_btn_primary__RP8j-"};